import { AddCmpProjectDialogState } from ".";

export const addCmpProjectDialogInitialState: AddCmpProjectDialogState = {
  projectType: "",
  dipByRegion: "",
  rootComponentId: "",
  componentId: "",
  protocol: "",
  changeTarget: [],
  partner: "",
  projectTypeList: [],
  dipByRegionList: [],
  componentIdMap: new Map<string, any>(),
  filteredComponentIdList: [],
  protocolMap: new Map<string, any>(),
  filteredProtocolList: [],
  changeTargetOption: [
    { label: "EDH Attribute", value: "Attribute" },
    { label: "Infrastructure", value: "Infrastructure" },
  ],
  partnerList: [],
  isShow: false,
  isEdited: false,
  fieldPath: {
    cpntPjtTypeCd: "cpntPjtTypeCd",
    dipByRgn: "dipByRgn",
    cpntId: "cpntId",
    ptnrId: "ptnrId",
    prtclTypeCd: "prtclTypeCd",
    changeAttributeFlg: "changeAttributeFlg",
  },
};
